import React from 'react';

export const LoadingSpinner = ({ size = 'md', text }) => {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };
  
  return (
    <div className="flex flex-col items-center justify-center gap-3" data-testid="loading-spinner">
      <div className={`${sizeClasses[size]} relative`}>
        <div className="absolute inset-0 rounded-full border-2 border-slate-200"></div>
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#2563EB] animate-spin"></div>
      </div>
      {text && (
        <p className="text-sm text-slate-600 animate-pulse">{text}</p>
      )}
    </div>
  );
};

export const LoadingSkeleton = ({ className }) => {
  return (
    <div className={`skeleton rounded-xl ${className}`} data-testid="loading-skeleton"></div>
  );
};
